import { omniConfig } from '@omnipresentgroup/design-system';

export const borderSubtle = `${omniConfig.theme.borderWidths.s} ${omniConfig.theme.borderStyles.solid} ${omniConfig.theme.colors['border-subtle']}`;
export const borderAlert = `${omniConfig.theme.borderWidths.m} ${omniConfig.theme.borderStyles.solid} ${omniConfig.theme.colors['banner-notification-border-warning']}`;
